// import { components } from "react-select";
// import Forgotpassword from "../auth/forgotpassword/forgotpassword";
// import ResetPassword from "../auth/forgotpassword/resetpassword";
// import { LogIn } from "../auth/login";
// import Fax from "../fax/fax";
// import HelloDev from "../hellodev";
// import CareLanding from "../landingscreen/brainycarehome";
// import Orders from "../orders/orders";
// import RpmDevices from "../rpm/devices/rpmdevices";
// import rpmreports from "../rpm/devices/rpmreports";
// import Rpm from "../rpm/rpm";
// import Schedule from "../schedule/schedule";
// import SigninTab from "../signin/signin";
// import Procedures from "../tabs/procedures/procedures";
// import Refills from "../tabs/refills/refills";
// import Tasks from "../tasks/tasks";
// import UserTab from "../user/user";
// import rpmAnalytics from "../rpm/devices/rpmAnalytics";
// import Reporthome from "../Reports/Reporthome";
// import Editscreen from "../blinkscribe/archeivescreens/editscreen";
// import Waitinghome from "../WaitingRoom/Waitinghome";
// import ExpireResetPassword from "../auth/forgotpassword/Passwordexpire";
// import Inventory from "../inventory/inventory";
// import Onboarding from "../onboarding/onboarding";
// import ColorCoding from "../colorcoding/colorcoding";
// import ThyroidUltrasoundview from "../Forms/views/thyroidultrasound";
// import AbdominalUltrasoundview from "../Forms/views/abdominalultrsoundview";
// import AbdominalUltrasoundDopplerview from "../Forms/views/abdominalultrasounddopplerview";
// import AortaUltrasoundview from "../Forms/views/AortaultrasounndView";
// import BladderUltrasoundviewPreliminary from "../Forms/views/bladderultrasoundpreliminaryview";
// import BreastUltraSoundView from "../Forms/views/breastultrsoundview";
// import RenalDopplerView from "../Forms/views/renaldopplerview";
// import LowerExtremelyVenousDopplerView from "../Forms/views/lowerextremelyvenousview";
// import TestucularUltrasoundview from "../Forms/views/testicularultrasoundview";

// import ProTransAbdominalView from "../Forms/views/protransabdominalview";
// import OrthoultrasoundView from "../Forms/views/orthoultrasoundview";
// import EstimView from "../Forms/views/estimview";
// import ManageProfile from "../pages/manageprofile/ManageProfile";
// import PelvicView from "../Forms/views/pelvicView";
// import PatientOnboarding from "../patientonboarding/PatientOnboarding";

// import CCMScreen from "../ccm/ccm";
// import FacialRecognization from "../facialrecognization/onBoarding/onBoarding";
// import ViewOnBoardEmployees from "../facialrecognization/views/Viewonboardemp";
// import EmployeeTimesheets from "../timesheets/employeeTimesheet/employeetimesheets";
// import HomesleepLink from "../landingscreen/patientcharts/tabs/forms/sharablehtmls/homesleepq";
// import DocumentLinkSwitcher from "../landingscreen/patientcharts/tabs/forms/sharablehtmls/documentlinkswitcher";
// import PatientOnboarding111 from "../patientonboarding/patientonboarding1111";
// import PatientOnboardingpublic from "../patientonboarding/patientonboardingpublic";
// import MedTrack from "../MedTrack/MedTrack";
// import Logs from "../logs/log";

// export const routes = [
//   {
//     path: '/landing',
//     component: CareLanding,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/login',
//     component: LogIn,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/forgotpassword',
//     component: Forgotpassword,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/reset-password/:id',
//     component: ExpireResetPassword,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/reset/:token',
//     component: ResetPassword,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/pro',
//     component: Procedures,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/ref',
//     component: Refills,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/dev',
//     component: HelloDev,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/usthyroid-Preview/:filename',
//     component: ThyroidUltrasoundview,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/usabdominal-Preview/:filename',
//     component: AbdominalUltrasoundview,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/usabdominal-doppler-Preview/:filename',
//     component: AbdominalUltrasoundDopplerview,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/usaorta-Preview/:filename',
//     component: AortaUltrasoundview,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/bladderPreliminary-Preview/:filename',
//     component: BladderUltrasoundviewPreliminary,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/breastus-Preview/:filename',
//     component: BreastUltraSoundView,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/renalDopplerus-Preview/:filename',
//     component: RenalDopplerView,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/LwrExtrmVnsDpler-Preview/:filename',
//     component: LowerExtremelyVenousDopplerView,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/testicularUltrasound-Preview/:filename',
//     component: TestucularUltrasoundview,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/testicularUltrasound-Preview/:filename',
//     component: TestucularUltrasoundview,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/prostateTransAbdominal-Preview/:filename',
//     component: ProTransAbdominalView,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/orthous-Preview/:filename',
//     component: OrthoultrasoundView,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/estim-Preview/:filename',
//     component: EstimView,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/uspelvic-Preview/:filename',
//     component: PelvicView,
//     showHeader: false,
//     privilege: ''
//   },
//    {
//     path: '/doc/:type/:patientid/:filename',
//     component:DocumentLinkSwitcher,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/orders/:id/:dt/:filter',
//     component: Orders,
//     showHeader: true,
//     privilege: ''
//   },
//   //  {
//   //     path: '/careiq',
//   //     component: CareIq,
//   //     showHeader: true,
//   //     privilege: ''
//   //   },
//   {
//     path: '/rpm',
//     component: Rpm,
//     showHeader: true,
//     privilege: 'RPM'
//   },
//   {
//     path: '/rpm-devices',
//     component: RpmDevices,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/rpm-reports',
//     component: rpmreports,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/rpm-analytics',
//     component: rpmAnalytics,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/waiting-room',
//     component: Waitinghome,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/signtab',
//     component: SigninTab,
//     showHeader: true,
//     privilege: 'SignIn Sheet'
//   },
//   {
//     path: '/reports',
//     component: Reporthome,
//     showHeader: true,
//     privilege: 'Reports'
//   },
//   {
//     path: '/user',
//     component: UserTab,
//     showHeader: true,
//     privilege: 'Users'
//   },
//   {
//     path: '/tasks',
//     component: Tasks,
//     showHeader: true,
//     privilege: 'Tasks'
//   },
//   {
//     path: '/fax',
//     component: Fax,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/schedule',
//     component: Schedule,
//     showHeader: true,
//     privilege: 'Scheduler'
//   },

//   {
//     path: '/archive-edit/:id/:name',
//     component: Editscreen,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/inventory',
//     component: Inventory,
//     showHeader: true,
//     privilege: 'Inventory'
//   },
//   {
//     path: '/logs',
//     component:Logs,
//     showHeader: true,
//     privilege: 'Logs'
//   },
//   {
//     path: '/onboarding',
//     component: Onboarding,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/manage-profile',
//     component: ManageProfile,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/patient',
//     component: PatientOnboarding,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/patient1111',
//     component: PatientOnboarding111,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/patient-enrollment',
//     component: PatientOnboardingpublic,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/colorcode',
//     component: ColorCoding,
//     showHeader: true,
//     privilege: ''
//   },
//    {
//     path: '/ccm',
//     component: CCMScreen,
//     showHeader: true,
//     privilege: ''
//   },

//    {
//     path: '/onboard-emp',
//     component:FacialRecognization,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/view-emp',
//     component:ViewOnBoardEmployees,
//     showHeader: true,
//     privilege: ''
//   },
//    {
//     path: '/timesheets',
//     component:EmployeeTimesheets,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/medtrack/:ak',
//     component: MedTrack,
//     showHeader: false,
//     privilege: ''
//   }
// ];

import { components } from "react-select";
import Forgotpassword from "../auth/forgotpassword/forgotpassword";
import ResetPassword from "../auth/forgotpassword/resetpassword";
import { LogIn } from "../auth/login";
import Fax from "../fax/fax";
import HelloDev from "../hellodev";
import CareLanding from "../landingscreen/brainycarehome";
import Orders from "../orders/orders";
import RpmDevices from "../rpm/devices/rpmdevices";
import rpmreports from "../rpm/devices/rpmreports";
import Rpm from "../rpm/rpm";
import Schedule from "../schedule/schedule";
import SigninTab from "../signin/signin";
import Procedures from "../tabs/procedures/procedures";
import Refills from "../tabs/refills/refills";
import Tasks from "../tasks/tasks";
import UserTab from "../user/user";
import rpmAnalytics from "../rpm/devices/rpmAnalytics";
import Reporthome from "../Reports/Reporthome";
import Editscreen from "../blinkscribe/archeivescreens/editscreen";
import Waitinghome from "../WaitingRoom/Waitinghome";
import ExpireResetPassword from "../auth/forgotpassword/Passwordexpire";
import Inventory from "../inventory/inventory";
import Onboarding from "../onboarding/onboarding";
import ColorCoding from "../colorcoding/colorcoding";
import ThyroidUltrasoundview from "../Forms/views/thyroidultrasound";
import AbdominalUltrasoundview from "../Forms/views/abdominalultrsoundview";
import AbdominalUltrasoundDopplerview from "../Forms/views/abdominalultrasounddopplerview";
import AortaUltrasoundview from "../Forms/views/AortaultrasounndView";
import BladderUltrasoundviewPreliminary from "../Forms/views/bladderultrasoundpreliminaryview";
import BreastUltraSoundView from "../Forms/views/breastultrsoundview";
import RenalDopplerView from "../Forms/views/renaldopplerview";
import LowerExtremelyVenousDopplerView from "../Forms/views/lowerextremelyvenousview";
import TestucularUltrasoundview from "../Forms/views/testicularultrasoundview";
import EchoView from "../Forms/views/echoview";
import CarotidView from "../Forms/views/carotidview";
import VenousView from "../Forms/views/venousview";
import ArterialView from "../Forms/views/arterialview";

import ProTransAbdominalView from "../Forms/views/protransabdominalview";
import OrthoultrasoundView from "../Forms/views/orthoultrasoundview";
import EstimView from "../Forms/views/estimview";
import ManageProfile from "../pages/manageprofile/ManageProfile";
import PelvicView from "../Forms/views/pelvicView";
import PatientOnboarding from "../patientonboarding/PatientOnboarding";

import CCMScreen from "../ccm/ccm";
import FacialRecognization from "../facialrecognization/onBoarding/onBoarding";
import ViewOnBoardEmployees from "../facialrecognization/views/Viewonboardemp";
import EmployeeTimesheets from "../timesheets/employeeTimesheet/employeetimesheets";
import HomesleepLink from "../landingscreen/patientcharts/tabs/forms/sharablehtmls/homesleepq";
import DocumentLinkSwitcher from "../landingscreen/patientcharts/tabs/forms/sharablehtmls/documentlinkswitcher";
import PatientOnboarding111 from "../patientonboarding/patientonboarding1111";
import PatientOnboardingpublic from "../patientonboarding/patientonboardingpublic";
import MedTrack from "../MedTrack/MedTrack";
import Logs from "../logs/log";
import StrepCovidFluView from "../Forms/views/StrepCovidFluView";
import Prices from "../prices/price";
import PrintNotes from "../printnotes/PrintNotes";

export const routes = [
  {
    path: "/landing",
    component: CareLanding,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/login",
    component: LogIn,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/forgotpassword",
    component: Forgotpassword,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/reset-password/:id",
    component: ExpireResetPassword,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/reset/:token",
    component: ResetPassword,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/pro",
    component: Procedures,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/ref",
    component: Refills,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/dev",
    component: HelloDev,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/usthyroid-Preview/:filename",
    component: ThyroidUltrasoundview,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/usabdominal-Preview/:filename",
    component: AbdominalUltrasoundview,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/usabdominal-doppler-Preview/:filename",
    component: AbdominalUltrasoundDopplerview,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/usaorta-Preview/:filename",
    component: AortaUltrasoundview,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/bladderPreliminary-Preview/:filename",
    component: BladderUltrasoundviewPreliminary,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/breastus-Preview/:filename",
    component: BreastUltraSoundView,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/renalDopplerus-Preview/:filename",
    component: RenalDopplerView,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/LwrExtrmVnsDpler-Preview/:filename",
    component: LowerExtremelyVenousDopplerView,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/testicularUltrasound-Preview/:filename",
    component: TestucularUltrasoundview,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/testicularUltrasound-Preview/:filename",
    component: TestucularUltrasoundview,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/prostateTransAbdominal-Preview/:filename",
    component: ProTransAbdominalView,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/orthous-Preview/:filename",
    component: OrthoultrasoundView,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/estim-Preview/:filename",
    component: EstimView,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/uspelvic-Preview/:filename",
    component: PelvicView,
    showHeader: false,
    privilege: "",
  },
    {
    path: '/imaging/echo-Preview/:filename',
    component: EchoView,
    showHeader: false,
    privilege: ''
  },
    {
    path: '/imaging/carotid-Preview/:filename',
    component: CarotidView,
    showHeader: false,
    privilege: ''
  },
    {
    path: '/imaging/venous-Preview/:filename',
    component: VenousView,
    showHeader: false,
    privilege: ''
  },
    {
    path: '/imaging/arterial-Preview/:filename',
    component: ArterialView,
    showHeader: false,
    privilege: ''
  }, 
  {
    path: "/doc/:type/:patientid/:filename",
    component: DocumentLinkSwitcher,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/orders/:id/:dt/:filter",
    component: Orders,
    showHeader: true,
    privilege: "",
  },
  //  {
  //     path: '/careiq',
  //     component: CareIq,
  //     showHeader: true,
  //     privilege: ''
  //   },
  {
    path: "/rpm",
    component: Rpm,
    showHeader: true,
    privilege: "RPM",
  },
  {
    path: "/rpm-devices",
    component: RpmDevices,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/rpm-reports",
    component: rpmreports,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/rpm-analytics",
    component: rpmAnalytics,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/waiting-room",
    component: Waitinghome,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/signtab",
    component: SigninTab,
    showHeader: true,
    privilege: "SignIn Sheet",
  },
  {
    path: "/print-notes",
    component: PrintNotes,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/reports",
    component: Reporthome,
    showHeader: true,
    privilege: "Reports",
  },
  {
    path: "/user",
    component: UserTab,
    showHeader: true,
    privilege: "Users",
  },
  {
    path: "/tasks",
    component: Tasks,
    showHeader: true,
    privilege: "Tasks",
  },
  {
    path: "/imaging/strep-covid-flu-Preview/:filename",
    component: StrepCovidFluView,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/fax",
    component: Fax,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/schedule",
    component: Schedule,
    showHeader: true,
    privilege: "Scheduler",
  },

  {
    path: "/archive-edit/:id/:name",
    component: Editscreen,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/inventory",
    component: Inventory,
    showHeader: true,
    privilege: "Inventory",
  },
  {
    path: "/logs",
    component: Logs,
    showHeader: true,
    privilege: "Logs",
  },
  {
    path: "/onboarding",
    component: Onboarding,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/manage-profile",
    component: ManageProfile,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/patient",
    component: PatientOnboarding,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/patient1111",
    component: PatientOnboarding111,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/patient-enrollment",
    component: PatientOnboardingpublic,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/colorcode",
    component: ColorCoding,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/ccm",
    component: CCMScreen,
    showHeader: true,
    privilege: "",
  },

  {
    path: "/onboard-emp",
    component: FacialRecognization,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/view-emp",
    component: ViewOnBoardEmployees,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/timesheets",
    component: EmployeeTimesheets,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/medtrack/:ak",
    component: MedTrack,
    showHeader: false,
    privilege: "",
  },
    {
    path: "/prices",
    component: Prices,
    showHeader: true,
    privilege: "Prices",
  },
];
